import type {DateTimeModel} from '../../../../../core/domain/Date/DateTime.model';
import type {MetricModel} from '../../../../../core/domain/Metric/Metric.model';

export abstract class FetchMetricsQuery {
  abstract exec(
    props: FetchMetricsQuery.Props,
  ): Promise<FetchMetricsQuery.Response>;
}

export namespace FetchMetricsQuery {
  export type Props = {
    endDate: DateTimeModel;
    startDate: DateTimeModel;
  };
  export type Response = MetricModel[];
}
